import Table from "components/DataTable/Table";
import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";

function UpdateWOCustomer({
  selectedWorkOrder,
  showModal,
  refreshFunc,
  defaultShipmentMethodId,
}) {
  const dispatch = useDispatch();

  /*   All States
   ********************************************* */
  const [customerData, setCustomerData] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [filterBy, setFilterBy] = useState();
  const [showOrderNotesModal, setShowOrderNotesModal] = useState(false);

  const [loading, setLoading] = useState(false);

  const loadingOn = () => {
    setLoading(true);
  };
  const loadingOff = () => {
    setLoading(false);
  };

  /*   All functions
   ********************************************* */
  const getCustomersData = async () => {
    try {
      loadingOn();
      const { data } = await API.get("/customers", { headers: authHeader() });
      setCustomerData(data);
      loadingOff();
    } catch (err) {
      loadingOff();
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    }
  };

  const handleCustomerSelect = (item) => {
    setSelectedCustomer(item);
    // Same behaviour as picking a customer on Add Work Order — surface the
    // customer's order notes as soon as they're chosen. Only fires here, not
    // in getCustomerById, so pre-loading the WO's *existing* customer on open
    // doesn't pop the modal.
    setShowOrderNotesModal(!!item?.orderNotes);
  };

  const handleWOInfo = async (_selectedCustomer) => {
    // console.log("selectedCustomer", _selectedCustomer);

    // get default shipping address from api
    const { data } = await API.post(
      "/customer/ship-address/default/" + selectedWorkOrder?.customerId,
      {
        isPrimary: true,
      },
      {
        headers: authHeader(),
      },
    );

    let _shippingAddress = {};
    if (data?.success) {
      _shippingAddress = data?.data || {};
    } else {
      _shippingAddress = {};
    }

    if (!_selectedCustomer) {
      return alert("Please Select a customer");
    }

    if (!_selectedCustomer?.locationId) {
      return alert(
        "Selected Customer does not have a location assigned. Please assign a location to the customer before updating the work order.",
      );
    }

    let apiData = { data: {} };
    apiData.id = selectedWorkOrder?.id;

    if (!apiData?.id) {
      alert("Please Select a Work Order");
      return;
    }

    let billingAddress = {
      description: "",
      addressCompany: _selectedCustomer?.addressCompany,
      addressLine1: _selectedCustomer?.addressLine1,
      addressLine2: _selectedCustomer?.addressLine2,
      city: _selectedCustomer?.addressCity,
      state: _selectedCustomer?.addressState,
      zip: _selectedCustomer?.addressZipCode,
      country: _selectedCustomer?.addressCountry,
    };

    let shippingAddress = {
      description: _shippingAddress.description,
      addressCompany: _shippingAddress.companyName,
      addressLine1: _shippingAddress?.addressLine1,
      addressLine2: _shippingAddress?.addressLine2,
      city: _shippingAddress?.city,
      state: _shippingAddress?.state,
      zip: _shippingAddress?.zip,
      country: _shippingAddress?.country,
      email: _shippingAddress?.email,
      phone: _shippingAddress?.phone,
      signatureRelease: _shippingAddress?.signatureRelease,
      authorizePerson: _shippingAddress?.authorizePerson,
      selfCollect: _shippingAddress?.selfCollect,
      authorizeLocation: _shippingAddress?.authorizeLocation,
      serviceId: _shippingAddress?.serviceId,
      addressGroundTransitDays:
        _shippingAddress?.addressGroundTransitDays || null,
    };

    let WoDetails = {
      locationId: _selectedCustomer?.locationId,
      taxExamption: _selectedCustomer?.isTaxExamption,
      taxRateId: _selectedCustomer?.taxAccountId,
      paymentTermsId: _selectedCustomer?.paymentTermsId,
      salesPersonId: _selectedCustomer?.salesPersonId,
    };

    apiData.id = selectedWorkOrder?.id;

    let [firstName, lastName] = _selectedCustomer?.accountPayableContact
      ? _selectedCustomer?.accountPayableContact?.split(" ")
      : ["", ""];

    apiData.data = {
      ...apiData.data,
      ...WoDetails,
      // contactData: JSON.stringify({
      //   firstName: firstName,
      //   lastName: lastName,
      //   phone: _selectedCustomer?.accountPayablePhone,
      //   email: _selectedCustomer?.accountPayableEmail,
      // }),
      customerId: _selectedCustomer?.id,
      customerName: _selectedCustomer?.customerName,
      billingAddress,
      shippingAddress,
      ...(defaultShipmentMethodId
        ? { shipmentMethod: defaultShipmentMethodId }
        : {}),
    };

    try {
      loadingOn();
      const { data } = await API.patch("/work-orders", apiData, {
        headers: authHeader(),
      });

      if (data?.message?.type === "success") {
        await refreshFunc();
        loadingOff();
        showModal(false);
        return;
      }
      console.log(data);
      alert("something went wrong! Check Logs.");
    } catch (err) {
      loadingOff();
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    }
  };

  const getCustomerById = async (id) => {
    if (!id) return;

    try {
      const { data } = await API.get(`/customers/${id}`, {
        headers: authHeader(),
      });
      if (data?.success) {
        setSelectedCustomer(data?.data);
      } else {
        dispatch(
          setNotification({
            message: "Customer not found",
            type: "error",
          }),
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    }
  };

  /*   ALL TABLES FUNCTIONS
   ********************************************* */

  const buttons = () => (
    <div className=" d-flex justify-content-end ">
      {/* FilterBy */}
      <button
        type="button"
        className="px-1 bg-primary btn text-dark bg-opacity-10 border border-primary rounded-end mx-2 rounded-start"
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        {filterBy
          ? filterBy.toUpperCase().replaceAll("_", " ")
          : "Filter by All"}
      </button>
      <div className="dropdown-menu">
        <button onClick={() => setFilterBy(null)} className="dropdown-item">
          Filter by All
        </button>
        <button
          onClick={() => setFilterBy("companyName")}
          className="dropdown-item"
        >
          Company Name
        </button>
        <button
          onClick={() => setFilterBy("externalCustomerId")}
          className="dropdown-item"
        >
          External ID
        </button>
        <button
          onClick={() => setFilterBy("website")}
          className="dropdown-item"
        >
          Website
        </button>
        <button
          onClick={() => setFilterBy("isTaxExemption")}
          className="dropdown-item"
        >
          Tax Exampted
        </button>
        <button
          onClick={() => setFilterBy("customerType")}
          className="dropdown-item"
        >
          Customer Type
        </button>
      </div>
    </div>
  );

  const table_head = [
    "ID",
    "Customer Name",
    "External ID",
    "Customer Website",
    "Tax Exempted",
    "Customer Type",
    "Actions",
  ];

  const table_body = (item) => (
    <tr className="" key={item.id}>
      <td className="py-1 my-0 align-middle">C-{item?.customerId}</td>
      <td className="py-1 my-0 align-middle">{item?.customerName} </td>
      <td className="py-1 my-0 align-middle">{item?.externalCustomerId}</td>
      <td className="py-1 my-0 align-middle">{item?.website}</td>
      <td className="py-1 my-0 align-middle">
        {item?.isTaxExemption?.toString()}{" "}
      </td>
      <td className="py-1 my-0 align-middle">{item?.customerType} </td>
      <td className="table-action py-1 my-0 align-middle">
        <div
          className="btn btn-sm btn-success"
          onClick={() => {
            handleCustomerSelect(item);
          }}
        >
          SELECT
        </div>
      </td>
    </tr>
  );

  useEffect(() => {
    let timeout = setTimeout(() => {
      getCustomersData();
    }, 50);
    return () => clearTimeout(timeout);
  }, [selectedWorkOrder]);

  useEffect(() => {
    let timeout = setTimeout(() => {
      if (selectedWorkOrder?.customer) {
        getCustomerById(selectedWorkOrder?.customer?.customerId);
      }
    }, 50);
    return () => clearTimeout(timeout);
  }, [selectedWorkOrder]);

  return (
    <div className="px-4 py-2 bg-white shadow-lg" style={{ borderRadius: 10 }}>
      {loading && <Spinner />}
      <div className="d-flex mb-2 justify-content-between align-items-center">
        <h3>Update WO Info</h3>
        <div>
          <button
            disabled={!selectedCustomer}
            onClick={() => {
              handleWOInfo(selectedCustomer);
            }}
            className="btn btn-success"
          >
            Save
          </button>
          <button
            onClick={() => {
              showModal(false);
            }}
            className="ms-1 btn btn-secondary"
          >
            Close
          </button>
        </div>
      </div>

      {selectedCustomer && selectedCustomer?.locationId ? (
        <div className="">
          <h4>Selected Customer</h4>
          <div className="bg-white w-full custom-shadow-sm custom-border-radius-sm px-2 py-1">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <span className="me-3">C-{selectedCustomer?.customerId}</span>
                <span>{selectedCustomer?.customerName}</span>
              </div>
              {/* <div>
                <span className="me-3">{selectedCustomer?.locationId}</span>
              </div> */}

              <div>
                <button
                  onClick={() => handleWOInfo(selectedCustomer)}
                  className="btn btn-sm btn-info me-1"
                >
                  <i className="mdi mdi-update"></i>
                </button>
                <button
                  onClick={() => {
                    setSelectedCustomer(null);
                  }}
                  className="btn btn-sm btn-danger"
                >
                  <i className="mdi mdi-trash-can"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          {!selectedCustomer ? (
            <div className="alert alert-info">
              Please select a customer to update the work order.
            </div>
          ) : (
            <div className="alert alert-info">
              Selected Customer does not have a location assigned. Please assign
              a location to the customer before updating the work order.
            </div>
          )}
        </>
      )}

      <div className={`d-flex justify-content-end mt-3`}>
        <div className="horizontal-scrollable d-flex  flex-grow-1">
          {customerData && (
            <Table
              filterBy={filterBy}
              buttons={buttons}
              defaultLimit={5}
              table_head={table_head}
              table_body={table_body}
              table_data={customerData}
            />
          )}
        </div>
      </div>

      <Modal
        show={showOrderNotesModal}
        onHide={() => setShowOrderNotesModal(false)}
        centered
        contentClassName="shadow-lg border border-2 border-primary"
        backdropClassName="order-notes-backdrop"
        style={{ zIndex: 1090 }}
      >
        <style>{`
          .order-notes-backdrop {
            z-index: 1085 !important;
            background-color: rgba(0, 0, 0, 0.6) !important;
            opacity: 1 !important;
          }
        `}</style>
        <Modal.Header closeButton>
          <Modal.Title>
            Order Notes for {selectedCustomer?.customerName}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ whiteSpace: "pre-wrap" }}>
            {selectedCustomer?.orderNotes}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setShowOrderNotesModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default UpdateWOCustomer;
